import { useMutation } from '@tanstack/react-query';

import { CashFlowApi } from '../cashFlow.api';

export const useGetCashToSupplierCalculation = () => {
  return useMutation({
    mutationFn: CashFlowApi.getCashToSupplierCalculation,
  });
};
